import PropTypes from 'prop-types';

import { dateUtils } from '../../../../routes/utils';
import { BookingContext, bookingClassNameModifier } from '../../booking.context';
import styles from '../BookingDate.scss';

export const DateSlot = ({ date, children }) => {
  const day = date.getDate();
  return (
    <BookingContext.Consumer>
      {(context) => (
        <div
          className={styles[`${bookingClassNameModifier(context)}BookingReview__date`]}
          data-testid="appointmentDate"
        >
          <div className={styles[`${bookingClassNameModifier(context)}BookingReview__date_left`]}>
            <div>
              <strong
                className={styles[`${bookingClassNameModifier(context)}BookingReview__date__day`]}
              >
                {day}
              </strong>
              <span
                className={
                  styles[`${bookingClassNameModifier(context)}BookingReview__date__day_name`]
                }
              >
                {dateUtils.getMonthFullName(date.getMonth())}
              </span>
            </div>
          </div>
          <div>
            <strong
              className={styles[`${bookingClassNameModifier(context)}BookingReview__date__month`]}
            >
              {`
                  ${dateUtils.getDayFullName(date.getDay())}
                  ${day}
                  ${dateUtils.getMonthFullName(date.getMonth())}
                  ${date.getFullYear()}
                `}
            </strong>
            {children}
          </div>
        </div>
      )}
    </BookingContext.Consumer>
  );
};

DateSlot.propTypes = {
  date: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
};
